import { createContext } from "react";

const FreeContext = createContext(undefined as any);

export default FreeContext;
